var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 78.785 78.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16709",
    "data-name": "Group 16709",
    transform: "translate(-222 -969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32331",
    "data-name": "Path 32331",
    d: "M45.769,78.8H12.37A12.327,12.327,0,0,1,.057,66.49V12.313A12.327,12.327,0,0,1,12.37,0H50.215A12.327,12.327,0,0,1,62.528,12.313V23.548a3.078,3.078,0,0,1-6.156,0V12.313a6.163,6.163,0,0,0-6.156-6.156H12.37a6.163,6.163,0,0,0-6.156,6.156V66.49a6.163,6.163,0,0,0,6.156,6.156h33.4A3.078,3.078,0,0,1,45.769,78.8ZM27.145,49.252H15.431a3.078,3.078,0,0,1,0-6.156H27.145A3.078,3.078,0,0,1,27.145,49.252Zm14.16-12.313H15.431a3.078,3.078,0,0,1,0-6.156H41.305A3.078,3.078,0,0,1,41.305,36.939Zm5.832-12.313H15.431a3.078,3.078,0,0,1,0-6.156H47.137A3.078,3.078,0,0,1,47.137,24.626Z",
    transform: "translate(221.943 969)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32332",
    "data-name": "Path 32332",
    d: "M69.01,76.8A3.078,3.078,0,0,1,66.85,71.53l4.026-3.963H50.694a3.078,3.078,0,0,1,0-6.156H70.876L66.85,57.448a3.078,3.078,0,1,1,4.318-4.388l4.95,4.872a9.255,9.255,0,0,1,.008,13.105l-4.959,4.88a3.068,3.068,0,0,1-2.159.885ZM57.466,56.024a3.068,3.068,0,0,1-2.159-.884l-4.95-4.872a9.255,9.255,0,0,1-.008-13.105l4.959-4.88a3.078,3.078,0,0,1,4.318,4.388L55.6,40.633H75.782a3.078,3.078,0,0,1,0,6.156H55.6l4.026,3.963a3.078,3.078,0,0,1-2.159,5.272Z",
    transform: "translate(221.943 969)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedDocuments);
export default __webpack_public_path__ + "static/media/SharedDocuments.e91dbc6323ff2717e72bf4df3a9cc20f.svg";
export { ForwardRef as ReactComponent };